import { Controller } from '@hotwired/stimulus'
import { formatDistanceToNow } from 'date-fns'
import { es } from 'date-fns/locale/es'
import { enUS } from 'date-fns/locale/en-US'

export class TimeagoController extends Controller {
  static values = {
    datetime: String,
    refreshInterval: Number,
    includeSeconds: { type: Boolean, default: true },
    addSuffix: { type: Boolean, default: false },
    locale: { type: String, default: 'en' }
  }

  initialize () {
    this.isValid = true
    this.locale = this.localeValue === 'es' ? es : enUS
    this.options = {
      includeSeconds: this.includeSecondsValue,
      addSuffix: this.addSuffixValue,
      locale: this.locale
    }
  }

  connect () {
    this.load()
    this.update()

    if (this.hasRefreshIntervalValue && this.isValid) {
      this.startRefreshing()
    }
  }

  disconnect () {
    this.stopRefreshing()
  }

  load () {
    this.date = Date.parse(this.datetimeValue)

    if (Number.isNaN(this.date)) {
      this.isValid = false

      console.error(
        `[timeago] Value given in 'data-timeago-datetime' is not a valid date (${this.datetimeValue}). Please provide a ISO 8601 compatible datetime string. Displaying given value instead.`
      )
    }
  }

  update () {
    // Both branches are plain text (date-fns output, or the raw value echoed back on the
    // invalid path). textContent, not innerHTML: the raw value can be host/user data.
    this.element.textContent = this.isValid
      ? formatDistanceToNow(this.date, this.options)
      : this.datetimeValue
  }

  startRefreshing () {
    this.refreshTimer = setInterval(() => {
      this.update()
    }, this.refreshIntervalValue)
  }

  stopRefreshing () {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer)
    }
  }
}
